export const checkFetchError = (status: number): void => {
  if (status >= 400 && status < 600) {
    throw new Error(
      status.toString()
    )
  }
}
